<template>
    <div v-if="$store.state.isModalOpenTwo" class="modal fade show modal-view" aria-labelledby="addNewCardTitle">
        <div class="modal-dialog modal-dialog-centered" ref="modalRef">
            <div class="modal-content p-2">
                <div v-for="(item, index) in saleMasters" :key="index">
                    <div class="d-flex justify-content-center align-items-center p-1">
                        <span class="text-center">{{ item.bill_number }}</span>
                        <button class="btn btn-secondary btn-sm curosr-pointer mx-1"
                            @click="goToPrint(item.id, 1)"
                        >
                            <i class="fas fa-print"></i>
                        </button>
                        <button class="btn btn-secondary btn-sm btn-challan"
                            @click="goToPrint(item.id, 2)"
                        >
                            <i class="fas fa-print"></i>
                        </button>
                    </div>
                </div>

                <div class="col-12 text-center mt-2">
                    <button @click.prevent="onClickClose" class="btn btn-outline-secondary waves-effect">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from 'vue-router';
import handlePurchase from "@/services/modules/purchase";
import handleBarcode from "@/services/modules/barcode";
import pdfPrinter from '@/services/utils/pdfPrinter';
import useDate from "@/services/utils/day";
import handleHospital from '@/services/modules/hospital';

const { fetchSalesBill } = handlePurchase();
const { fetchBarcode } = handleBarcode();
const { exportToPDF } = pdfPrinter();
const { formatDate } = useDate();
const { notesByType } = handleHospital();

const props = defineProps({
    saleMasters: Array
})

const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const companyInfo = ref({});
const invoice = ref({});
const barcodeQuery = ref('');
const barcode = ref('');
const qrcode = ref('');
const invoiceNotes = ref([]);

const onClickClose = () => {
    $store.state.isModalOpenTwo = false;
}

const goToPrint = async (id, btnFunc) => {
  try {
    const companyQuery = `?company_id=${$route.params.companyId}`;
    const user = $store.state.user.user

    const res = await fetchSalesBill(id, companyQuery);
    if (res) {
        invoice.value = res.data;

        const qrcodeData = JSON.stringify({
            ref_no: invoice.value.bill_number,
            ref_date: invoice.value.date,
            created_by: invoice.value.created_by_name,
            created_date_time: formatDate(new Date())
        });

        barcodeQuery.value = `?code=${invoice.value.bill_number}&qrcode=${qrcodeData}`;
    }

    // Fetch barcode and QR code
    const barcodeRes = await fetchBarcode(barcodeQuery.value);
    barcode.value = barcodeRes.barcode;
    qrcode.value = barcodeRes.qrcode;

    // Export PDF
    exportToPDF(
        companyInfo,
        invoice.value,
        barcode.value,
        qrcode.value,
        user.name,
        btnFunc,
        invoiceNotes.value
    );

  } catch (error) {
    console.log("Something went wrong", error);
  }
};
</script>

<style scoped>
.btn-challan {
    background-color: #249024 !important;
}

.modal-view {
    display: block; 
    background: #1c1d1c33;
}
</style> 
